import { Languages } from "src/common/descriptions/types";
import { ContractPaymentsDescriptions } from "./types";

const DescriptionsEnUs: ContractPaymentsDescriptions = {
    TITLE: "Contract Payments Records",
    TABLE: {
        ACTION_BUTTON: "Get Records",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Datetime",
        CUSTOMER: "Customer",
        DESCRIPTION: "Description",
        TOTAL: "Total Payed",
        CASH: "Cash",
        TRANSACTION: "Transaction",
        DISSCOUNT: "Disscount",
        ACTIONS: "Actions",
    },
    DOWNLOAD: "Download",
    VOUCHER: {
        TITLE: "Payment Receipt",
        RECEIVED_FROM: "Received From:",
        ADDRESS: "Address:",
        DATETIME: "Date of Payment:",
        KEY: "No",
        DESCRIPTION: "Description",
        TOTAL: "Total",
        TOTAL_AS_WORDS: "Total as words:",
        CASH: "Cash:",
        TRANSACTION: "Transaction:",
        OTHER: "Other:",
        PRINTED_AT: "Printed at:",
        LAST_ITEM: "***** Last item *****",
    },
    SENDING_RECEIPT_TITLE: "Sending Payment Receipt",
    SENDING_RECEIPT_DESCRIPTION: "",
    SENDING_RECEIPT_TITLE_CONFIRMATION: "Send Payment Receipt?",
}

const DescriptionsEsUs: ContractPaymentsDescriptions = {
    TITLE: "Pagos de Servicios",
    TABLE: {
        ACTION_BUTTON: "Ver Registros",
        SEARCH_PLACEHOLDER: "Buscar",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Fecha",
        CUSTOMER: "Cliente",
        DESCRIPTION: "Descripción",
        TOTAL: "Total Pagado",
        CASH: "Efectivo",
        TRANSACTION: "Transacción",
        DISSCOUNT: "Descuento",
        ACTIONS: "Acciones",
    },
    DOWNLOAD: "Descargar",
    VOUCHER: {
        TITLE: "Recibo de Pago",
        RECEIVED_FROM: "Recibimos de:",
        ADDRESS: "Dirección:",
        DATETIME: "Fecha de Pago:",
        KEY: "No",
        DESCRIPTION: "Descripción",
        TOTAL: "Total",
        TOTAL_AS_WORDS: "Total en letras:",
        CASH: "Efectivo:",
        TRANSACTION: "Transacción:",
        OTHER: "Otro:",
        PRINTED_AT: "Impreso:",
        LAST_ITEM: "***** Últimea línea *****",
    },
    SENDING_RECEIPT_TITLE: "Envando Comprobante de Pago",
    SENDING_RECEIPT_DESCRIPTION: "",
    SENDING_RECEIPT_TITLE_CONFIRMATION: "Enviar comprobante de pago?",
}

export const contractPaymentsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
